import { Outlet } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';

/**
 * Static branding panel + swappable form content (via Outlet) for the
 * auth-flow routes — ported pattern from the B2C reference app's
 * AuthLayout (left panel stays static, only the form changes).
 */
export default function AuthLayout() {
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12 lg:px-20">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-8 flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded bg-primary text-sm font-bold text-white">D</div>
            <span className="text-xl font-semibold text-text-primary">DECIXA</span>
          </div>
          <Outlet />
        </div>
      </div>
      <div className="hidden flex-col items-center justify-center bg-primary px-12 text-white lg:flex">
        <ShieldCheck className="mb-6 h-16 w-16" aria-hidden="true" />
        <h2 className="text-2xl font-semibold">AI-Powered Procurement Compliance</h2>
        <p className="mt-3 max-w-sm text-center text-white/80">
          Ensure procurement compliance, manage approvals, and navigate policies efficiently.
        </p>
      </div>
    </div>
  );
}
